<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="references">
<h1>References</h1>
<p><strong>Aas K (1989):</strong> To win with a wheeze. Mediglobe, Fribourg. ISBN: 28823900178.</p>
<p><strong>Kopot A</strong> <strong>(2014):</strong> AK lectures: <a href="http://www.aklectures.com/subject/organic-chemistry" target="_blank">Organic chemistry</a>.</p>
<p><strong>Kopot A</strong> (<strong>2014):</strong> AK lectures: <a href="http://www.aklectures.com/subject/general-chemistry" target="_blank">General chemistry</a>.</p>
<p><strong>Lewis RG et al (1999):</strong> Distribution of pesticides and polycyclic aromatic hydrocarbons in house dust as a function of particle size. Environ Health Perspect; 107: 721 – 26<a href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC1566465/pdf/envhper00514-0069.pdf" target="_blank">. Free article</a>.</p>
<p><strong>Noy D (1987):</strong> Persoonlijke blootstelling aan NO<sub>2</sub> in Nederland. Publikatiereeks Lucht 62, Ministerie VROM (<em>in Dutch</em>).</p>
<p><strong>O’Donnell B (2014):</strong> <em>Exposure</em> – the hidden threats that are making us sick. Horizon, the <a href="http://horizon-magazine.eu/article/exposure-hidden-threats-are-making-us-sick_en.html" target="_blank">EU Research &amp; Innovation Horizon Magazin<strong>e</strong></a><strong>,</strong> 01 September 2014.</p>
<p><strong>Pääbo S (2014):</strong> The human condition – a molecular approach. Cell; 157: 216 – 26. <a href="http://www.cell.com/cell/fulltext/S0092-8674(13)01605-X" target="_blank">Free article.</a></p>
<p><a href="http://www.ncbi.nlm.nih.gov/pubmed?term=Sankararaman%20S%5BAuthor%5D&amp;cauthor=true&amp;cauthor_uid=24476815" target="_blank"><strong>Sankararaman S</strong></a> et al <strong>(2014):</strong> The landscape of Neanderthal ancestry in present-day humans<strong>.</strong> Nature; 507:354 – 7. <a href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC4072735/" target="_blank">Free Article</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?76505e6b